export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  gradient: string;
  initials: string;
}

export const team: TeamMember[] = [
  {
    id: '1',
    name: 'Sidhant',
    role: 'Founder & Lead Developer',
    bio: 'A software developer driven by a conviction that great software should be private, performant, and a pleasure to use. Sidhant has designed, built, and published multiple apps on the Google Play Store — from Wallet and Path (privacy-first apps with zero data collection) to Nuzzle (an image puzzle game) and Calculator. He leads every project end-to-end: architecture, implementation, design sensibility, store listings, and ongoing maintenance. His philosophy is simple — build things you\'d be proud to use yourself, and never compromise on quality.',
    gradient: 'linear-gradient(135deg, #1ed760 0%, #0d7a3a 100%)',
    initials: 'S',
  },
  {
    id: '2',
    name: 'Akanksha',
    role: 'Lead Designer & Creative Director',
    bio: 'Akanksha shapes the visual identity of everything we create. From subreddit banners and logo systems to full web design and brand guidelines, she brings a meticulous eye for composition, color, and storytelling. Her work spans r/90sHipHop, r/CleverComeback, r/youtubeindia, and a collection of 13+ logos and 14+ banners. She believes every pixel carries intention — and that great design is the difference between something that works and something people love.',
    gradient: 'linear-gradient(135deg, #a855f7 0%, #6b21a8 100%)',
    initials: 'A',
  },
];
